<template>
  <BaseLabel :id="labelId" :short-text="shortText" :tooltip-text="tooltipText" :class-name="className" />
</template>

<script lang="ts">
import type { Assignment } from '@/types/Models/Assignment'
import { defineComponent } from 'vue'
import { RETURN, SINGLE } from '@/const/AssignmentTypes'
import { getAssignmentTypeTxt } from '@/services/Utils'
import BaseLabel from '@/views/Components/Labels/BaseLabel.vue'

export default defineComponent({
  name: 'AssignmentType',
  components: { BaseLabel },
  props: {
    assignment: {
      type: Object as () => Assignment,
      required: true,
    },
  },
  setup(props) {
    const labelId = `assignment-type-${props.assignment.id}`
    const tooltipText = getAssignmentTypeTxt(props.assignment.type)
    const shortText = props.assignment.type === SINGLE ? 'S' : props.assignment.type === RETURN ? 'R' : 'B'
    const className =
      props.assignment.type === SINGLE
        ? 'assignment-type-single'
        : props.assignment.type === RETURN
          ? 'assignment-type-return'
          : 'assignment-type-batch'

    return {
      labelId,
      shortText,
      tooltipText,
      className,
    }
  },
})
</script>
